import { useNavigate } from "react-router-dom";
import { customAuthAxios } from "../../../utils/customAuthAxios";
import { useSuccessToast } from "../../toast/useSuccessToast";


export const useRegisterLineDev = (restaurantId?: string) => {
  const navigate = useNavigate();
  const showToast = useSuccessToast();
  const onSubmit = async (data: any) => {
    data.restaurant = restaurantId;
    try {
      await customAuthAxios.post(`external_api/line-devs/`, data)
      showToast('登録が完了しました');
      navigate(-1);
    } catch (error: any) {
    }
  };
  return onSubmit;
};